import React, {useRef, useState} from 'react';
import { postImage } from '../../services/api-auto';
import styles from './styles.module.scss'

const ButtonEscolherArquivo = ({ changeImage, nomeArquivo, modalLoading }) => {

    const ref = useRef();
    const [error, setError] = useState('')

    const onImageChange = async (event, name) => {
        let file;
        setError('')
        if (event.target.files && event.target.files[0]) {
            file = event.target.files[0];
            if(file.type === 'application/pdf') {
                modalLoading(true);
                var link = await postImage(file);
                changeImage(link.data, file.name);
                modalLoading(false);
            } else {
                setError('Favor escolher arquivos nos seguintes formatos: PDF')
            }
        }
    };

    const callImageInput = () =>{
        ref.current.click()
    }

    return (
        <div className={styles.imageWrapper}>
            <input type='file' onChange={onImageChange} style={{display: 'none'}} ref={ref}/>
            <button onClick={callImageInput}>
                <div className={styles.imageButtonWrapperText}>
                    <div className={styles.imageWrapperTexto}>
                        {nomeArquivo ? "Arquivo selecionado" : "Escolher arquivo"}<br/>
                        <small>{nomeArquivo}</small>
                    </div>
                </div>
            </button>
            { error && (<div className={styles.messageError}>{error}</div>) }
        </div>
    )
}

export default ButtonEscolherArquivo;